/**
 * Display labels for emission units, written with a subscript ₂ and no space so every screen and
 * Excel export reads the same.
 */
export const KG_CO2E = "kgCO₂e";

export const T_CO2E = "tCO₂e";
